export const prices = [
  {
    _id: 0,
    name: 'Any',
    array: [],
  },
  {
    _id: 1,
    name: 'R$0 to R$5,000',
    array: [0, 5000],
  },
  {
    _id: 2,
    name: 'R$5,000 to R$20,000',
    array: [5000, 20000],
  },
  {
    _id: 3,
    name: 'R$20,000 to R$50,000',
    array: [20000, 50000],
  },
  {
    _id: 4,
    name: 'R$50,000 to R$100,000',
    array: [50000, 100000],
  },
  {
    _id: 5,
    name: 'Above 100,000',
    array: [100000, 90000000],
  },
];
